import {AbstractList} from "./abstract-list";

export class AllTaskList extends AbstractList {
  constructor(item: HTMLElement) {
    super(item);
  }
}
